<template>
	<div class="guest-vuestudio-wrapper">
		<slot />
	</div>
</template>
